import { Receipt } from "lucide-react";

/**
 * Placeholder (SPEC §4 T2). Scope previsto: repository delle fatture proforma e
 * di cortesia con stato pagato/da pagare. Non implementato in questo giro.
 */
export function AdminEconomiaFatturePage() {
  return (
    <div className="mx-auto max-w-2xl py-10 text-center">
      <div className="mx-auto mb-4 grid size-14 place-items-center rounded-2xl bg-muted">
        <Receipt className="size-7 text-muted-foreground" />
      </div>
      <h1 className="text-xl font-bold tracking-tight">Fatture</h1>
      <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
        Qui raccoglieremo le fatture proforma e di cortesia, con lo stato di
        pagamento. In arrivo in un prossimo rilascio.
      </p>
      <span className="mt-4 inline-block rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold text-brand-700">
        In arrivo
      </span>
    </div>
  );
}
